import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { NavigationBar } from './NavigationBar';

import { useState } from 'react';
import { useCheckAdmin } from '../hooks/useCheckAdmin'
import axios from 'axios';

import { BASE_URL } from '../utils/constants';

export const PageLayout = (props) => {
    const isAdminExist = useCheckAdmin();
    const [adminForm, setAdminForm] = useState({
        name: '',
        surname: '',
        email: '',
        password: ''
    });

    const [showMessage, setShowMessage] = useState(false);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setAdminForm(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleAdminFormSubmit = (e) => {
        e.preventDefault();
        const defaultAdminRequest = {
            Name: adminForm.name,
            Surname: adminForm.surname,
            Email: adminForm.email,
            Password: adminForm.password
        };

        axios.post(`${BASE_URL}/UserManagement/CreateDefaultAdmin`, defaultAdminRequest)
            .then(response => {
                // After successfully creating the admin:
                setShowMessage(true);

                setTimeout(() => {
                    setShowMessage(false); // Optional, since the page will refresh
                    window.location.reload(); // This will refresh the page
                }, 2000); // 2 seconds
            })
            .catch(error => {
                console.error("Error creating admin:", error);
                // Handle the error appropriately in your UI
            });
    }

    return (
        <>
            <NavigationBar />
            <UnauthenticatedTemplate>
                {
                    isAdminExist === false
                        ?
                        showMessage === false
                        ?
                            <div>
                                <h3>Create Default Admin</h3>
                                <form onSubmit={handleAdminFormSubmit}>
                                    <input name="name" placeholder="Name" onChange={handleInputChange} />
                                    <input name="surname" placeholder="Surname" onChange={handleInputChange} />
                                    <input name="email" placeholder="Email" onChange={handleInputChange} />
                                    <input type="password" name="password" placeholder="Password" onChange={handleInputChange} />
                                    <button type="submit">Create Admin</button>
                                </form>
                            </div>
                            :
                            <>
                                <br />
                                <h5>
                                    <center>Admin user successfully created</center>
                                </h5>
                                <br />
                            </>


                        : <>
                            <br />
                            <h5>
                                <center>Please sign in to MindCLOUD</center>
                            </h5>
                            <br />
                        </>
                }
            </UnauthenticatedTemplate>
            <AuthenticatedTemplate>
                {props.children}
            </AuthenticatedTemplate>
            <br />
            <AuthenticatedTemplate>
                <footer>
                    <center>
                        Authenticated
                    </center>
                </footer>
            </AuthenticatedTemplate>
        </>
    );
};

